import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core"
import React from "react"
import useAppStore from "../../../stores/AppStore"

export default function FiltroMesa() {
    const arrayTodosPedidos = useAppStore(s => s.arrayTodosPedidos)
    const filtroMesa = useAppStore(s => s.filtroMesa)
    const setFiltroMesa = useAppStore(s => s.setFiltroMesa)

    const mesas = Array.from(
        new Set(arrayTodosPedidos.filter(pedido => pedido.mesa).map(pedido => String(pedido.mesa)))
    ).sort((a, b) => Number(a) - Number(b))

    if (mesas.length === 0) return null

    return (
        <FormControl variant="outlined" style={{ minWidth: "120px" }}>
            <InputLabel>Mesa</InputLabel>
            <Select
                defaultValue={"todas"}
                value={filtroMesa}
                onChange={e => setFiltroMesa(e.target.value as string)}
                variant="outlined"
                displayEmpty
                label="Mesa"
                style={{ maxHeight: "40px", minWidth: "120px" }}
            >
                <MenuItem value={"todas"}>Todas</MenuItem>
                {mesas.map(mesa => (
                    <MenuItem key={mesa} value={mesa}>
                        Mesa {mesa}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}
